export default class SessionStorageKeys {
    public static readonly TIMEOUT_REDIRECT_TARGET = 'timeoutRedirectTarget';
}
